import { Moment } from 'moment'

import { Person } from '../../../App/store/features/person/IPerson'
import { IEvent } from '../../types'

export const currentColumnCalculation = (
  event: IEvent,
  persons: Person[],
  selectedDate: Moment,
): number => {
  let personPosition: number = persons.findIndex(
    person => person.id === event.personId,
  )

  if (personPosition === -1) {
    personPosition = 0
  }

  const dayNumber: number = event.startsAt
    .clone()
    .startOf('day')
    .diff(selectedDate.clone().startOf('day'), 'days')

  return dayNumber * persons.length + personPosition
}
